import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { lockSsoRouteProviders } from "../ssoRouteDependencies";
import { mutator } from "./mutator";

export const setPrimarySSOProvider = mutator({
  schema: z.object({ id: z.string(), isPrimary: z.boolean().optional() }),
  resolve: {
    provider: { kind: "ssoProvider", from: "id" },
  },
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { provider, isPrimary = true } }) => {
    await lockSsoRouteProviders(tx, ctx.tenantId);
    const target = await tx.run(zql.ssoProvider.where("id", provider.id).one());
    if (!target || (target.isPrimary ?? false) === isPrimary) return;
    const now = Date.now();
    if (isPrimary) {
      const [current] = await tx.run(
        zql.ssoProvider.where("tenantId", ctx.tenantId).where("isPrimary", true)
      );
      // Demote before promoting: the one-primary-per-tenant unique index is
      // checked per statement.
      if (current) {
        await tx.mutate.ssoProvider.update({
          id: current.id,
          isPrimary: false,
          updatedAt: now,
        });
      }
    }
    await tx.mutate.ssoProvider.update({
      id: provider.id,
      isPrimary,
      updatedAt: now,
    });
  },
});
